import { useState, useEffect } from "react";

export function TopButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        setVisible(window.scrollY > window.innerHeight * 0.5);
        ticking = false;
      });
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const toneClassName =
    "border-[rgba(var(--ip-primary-glow),0.25)] text-[var(--ip-primary)] shadow-[0_4px_20px_rgba(var(--ip-primary-glow),0.12)]";
  const hoverClassName =
    "hover:border-[var(--ip-primary)] hover:bg-[rgba(255,255,255,0.92)] hover:shadow-[0_6px_28px_rgba(var(--ip-primary-glow),0.2)]";

  return (
    <button
      className={`fixed bottom-10 right-10 max-md:bottom-5 max-md:right-4 z-[99] flex flex-col items-center gap-1 rounded border bg-[rgba(255,255,255,0.7)] px-3.5 py-3 text-[9px] font-semibold tracking-[0.15em] backdrop-blur-[12px] transition-all duration-300 ${toneClassName} ${
        visible
          ? "opacity-100 translate-y-0 pointer-events-auto"
          : "opacity-0 translate-y-3 pointer-events-none"
      } ${hoverClassName}`}
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label="Back to top"
    >
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path
          d="M8 12V4M8 4L4 8M8 4L12 8"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <span>TOP</span>
    </button>
  );
}
